'use strict';

var $ = require('jquery');
var urls = require('shared/scripts/modules/utils/urls');
var ajaxHandler = require('shared/scripts/modules/services/ajaxHandler');
var converter = require('shared/scripts/modules/utils/converter');

function getTransactionState() {
    var transactionId = urls.getUrlParameter("transaction-id");
    if (typeof transactionId === "undefined") {
        console.error("transaction-id not defined. Can't load transaction data");
        return ajaxHandler.ajaxPostJson({ url: process.env.contextRoot + '/rest/transactions' })
            .then(function(res) {
                urls.redirectToUrl(window.location.href + '?transaction-id=' + res.transactionId);
                return $.Deferred().reject();
            });
    } else {
        return ajaxHandler.ajaxGetJson({ url: process.env.contextRoot + '/rest/transactions/' + transactionId + '/details' })
            .then(function(res) {
                res.transactionId = transactionId;
                return convertToModel(res);
            })
            .fail(ajaxHandler.handleError('unable to get case details'));
    }
}

function postTransactionState(model) {
    var data = convertToBackend(model);
    var request = { url: process.env.contextRoot + '/rest/transactions/' + model.transactionId + '/details', jsonString: JSON.stringify(data) };
    return ajaxHandler.ajaxPostJson(request)
        .fail(ajaxHandler.handleError('unable to postTransactionState : ' + request.jsonString));
}

function convertToModel(data) {
    if (typeof data === 'undefined') {
        return {};
    }
    var result = $.extend({}, data);
    result.policyDate = converter.dateToUserFormat(result.policyDate);

    return result;
}

function convertToBackend(model) {
    var result = $.extend({}, model);
    delete result.transactionId;
    result.policyDate = converter.dateToServerFormat(result.policyDate);
    return result;
}

module.exports = {
    getTransactionState: getTransactionState,
    postTransactionState: postTransactionState
};



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/services/intlStateService.js
// module id = NI/0
// module chunks = 0 1 2 3 4